<template>
  <RouterView></RouterView>
  <GlobalSnackbar />
  <GlobalDialog />
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import GlobalSnackbar from '@/components/shared/GlobalSnackbar.vue';
import GlobalDialog from '@/components/shared/GlobalDialog.vue';
</script>

